import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateize',
    standalone: false
})
export class DateizePipe implements PipeTransform {
  transform(value: string | number | Date): any {
    if (!value) {
      return '';
    }

    // Formatted date strings vs '1502294299000' that should be treated as a number
    const v = Number.isNaN(+value) ? value : +value;

    const d = new Date(v);
    return d.toLocaleString('en-US');
  }
}
